import { render, staticRenderFns } from "./ResultsModal.vue?vue&type=template&id=885a9176&scoped=true"
import script from "./ResultsModal.vue?vue&type=script&lang=js"
export * from "./ResultsModal.vue?vue&type=script&lang=js"
import style0 from "./ResultsModal.vue?vue&type=style&index=0&id=885a9176&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885a9176",
  null
  
)

export default component.exports